module.exports = __webpack_public_path__ + "img/LogoLoading_circle02.491bf858.png";